import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MyGamesService, MyGamesStorage } from './infrastructure';
import { GetMyGamesQueryHandler, LoadMyGamesCommandHandler } from './application/handlers';
import { MyGamesRouting } from './my-games.routing';

@NgModule({
  imports: [RouterModule.forChild(MyGamesRouting)],
  providers: [MyGamesService, MyGamesStorage, LoadMyGamesCommandHandler, GetMyGamesQueryHandler]
})
export class MyGamesModule {}
